const Result = ({ status }) => {
  if (status === "success") {
    return <> ✅</>;
  } else if (status === "fail") {
    return <> ❌</>;
  } else if (status === "uploading") {
    return <> ⏳</>;
  } else {
    return null;
  }
};

export const Choose = ({ data, handleFileChange }) => {
  return (
    <div>
      <label htmlFor={`file_${data.id}`} style={data.style.labelStyle}>
        Choose file
      </label>
      <input
        id={`file_${data.id}`}
        type="file"
        style={{ display: "none" }}
        onChange={handleFileChange}
      />
    </div>
  );
};

export const Detail = ({ file, style, showDetail }) => {
  return showDetail
    ? file && (
        <div style={style}>
          File details:
          <ul>
            <li>Name: {file.name}</li>
            <li>Type: {file.type}</li>
            <li>Size: {file.size} bytes</li>
          </ul>
        </div>
      )
    : null;
};

export const Display = ({ file, style, setShowDetail }) => {
  return (
    <div
      style={style}
      onMouseEnter={() => setShowDetail(true)}
      onMouseLeave={() => setShowDetail(false)}
    >
      {file ? file.name : null}
    </div>
  );
};

export const Upload = ({ file, status, style, handleUpload }) => {
  return (
    file && (
      <div style={style} onClick={handleUpload}>
        Upload
        <Result status={status} />
      </div>
    )
  );
};

export const arrayBufferToBase64 = (buffer) => {
  var binary = "";
  var bytes = new Uint8Array(buffer);
  var len = bytes.byteLength;
  for (var i = 0; i < len; i++) {
    binary += String.fromCharCode(bytes[i]);
  }
  return window.btoa(binary);
};
